(function() {
  'use strict';

  var GAS_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbxaTJqdAtAVtKbgEJblmxJATP4gSlsV2qd9ZkdtOxAV-yvmXnU6tgMnoKTDN-tEGPEo/exec';
  var state = {
    form: null,
    submitButton: null,
    submitLabel: '',
    status: null,
    pageLoadTime: Date.now(),
    userInteracted: false,
    submitting: false,
    completed: false
  };

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function setField(name, value) {
    var field = qs('[name="' + name + '"]', state.form);
    if (field) field.value = value || '';
  }

  function getValue(name) {
    var field = qs('[name="' + name + '"]', state.form);
    return field ? String(field.value || '').trim() : '';
  }

  function getCheckedValues(name) {
    return qsa('input[name="' + name + '"]:checked', state.form).map(function(input) {
      return input.value;
    });
  }

  // 業者LPの対象者タブ（工務店/宿泊）。タブが無いページ（contact等）では '' を返す
  function getActiveAudience() {
    var el = document.querySelector('.biz-aud-tab-button.active');
    return el ? (el.getAttribute('data-aud') || '') : '';
  }

  function generateInquiryId() {
    var date = new Date();
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    var token = Math.random().toString(36).slice(2, 8).toUpperCase();
    return 'BUSINESS-' + y + m + d + '-' + token;
  }

  function getUrlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function parseProductHandle(url) {
    var source = url || window.location.href;
    try {
      var parsed = new URL(source, window.location.origin);
      var match = parsed.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function parseCollectionHandle() {
    var param = getUrlParam('collection_handle') || getUrlParam('collection');
    if (param) return param;
    try {
      var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function getDeviceInfo() {
    var ua = navigator.userAgent || '';
    return {
      type: /iPhone|Android.*Mobile/.test(ua) ? 'mobile' : (/iPad|Android/.test(ua) ? 'tablet' : 'desktop'),
      screenWidth: window.innerWidth || document.documentElement.clientWidth || '',
      browser: /Edg\//.test(ua) ? 'Edge' : (/Chrome\//.test(ua) ? 'Chrome' : (/Safari\//.test(ua) ? 'Safari' : (/Firefox\//.test(ua) ? 'Firefox' : 'unknown'))),
      os: /Windows/.test(ua) ? 'Windows' : (/Mac OS X/.test(ua) ? 'macOS' : (/iPhone|iPad/.test(ua) ? 'iOS' : (/Android/.test(ua) ? 'Android' : 'unknown')))
    };
  }

  function fillHiddenFields() {
    var productUrl = getUrlParam('product_url');
    var productHandle = getUrlParam('product_handle') || getUrlParam('product') || parseProductHandle(productUrl);
    var ctaLabel = getUrlParam('cta_label') || getUrlParam('cta') || getValue('cta_label') || 'business_inquiry_form';

    setField('inquiry_id', generateInquiryId());
    setField('current_url', window.location.href);
    setField('page_title', document.title);
    setField('cta_label', ctaLabel);
    setField('product_handle', productHandle);
    setField('collection_handle', parseCollectionHandle());
    setField('referrer', document.referrer || '');
    setField('utm_source', getUrlParam('utm_source'));
    setField('utm_medium', getUrlParam('utm_medium'));
    setField('utm_campaign', getUrlParam('utm_campaign'));
    setField('user_agent', navigator.userAgent || '');
    if (productUrl) setField('product_url', productUrl);
    if (getUrlParam('project_type')) setField('project_type', getUrlParam('project_type'));
  }

  function showStatus(message, isSuccess) {
    if (!state.status) return;
    state.status.textContent = message;
    state.status.hidden = false;
    state.status.classList.toggle('is-success', Boolean(isSuccess));
  }

  function clearStatus() {
    if (!state.status) return;
    state.status.textContent = '';
    state.status.hidden = true;
    state.status.classList.remove('is-success');
  }

  // 送信完了を明確に提示する（受付番号つき・画面内へスクロール）
  function showSuccess(payload) {
    var idText = payload && payload.inquiry_id ? '（受付番号：' + payload.inquiry_id + '）' : '';
    showStatus('送信が完了しました' + idText + '。3営業日以内に、担当者よりメールまたはお電話でご連絡いたします。', true);
    if (state.status && typeof state.status.scrollIntoView === 'function') {
      try { state.status.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
  }

  // 送信完了後、ボタンを「送信が完了しました」に固定して再送信を防ぐ
  function lockAsCompleted() {
    state.completed = true;
    if (state.submitButton) {
      state.submitButton.disabled = true;
      state.submitButton.classList.add('is-done');
      var label = qs('span', state.submitButton);
      if (label) label.textContent = '送信が完了しました';
    }
  }

  function trackValidationFail(fieldName, reason) {
    // 計測: どの項目で検証が止まったか（項目別離脱の把握・観測用）
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'form_validation_fail', { form_id: 'business', field_name: fieldName, reason: reason });
      }
    } catch (e) {}
  }

  function validate() {
    var required = [
      ['name', 'お名前を入力してください。'],
      ['email', 'メールアドレスを入力してください。'],
      ['message', '相談内容を入力してください。']
    ];

    for (var i = 0; i < required.length; i++) {
      if (!getValue(required[i][0])) {
        showStatus(required[i][1], false);
        trackValidationFail(required[i][0], 'required');
        return false;
      }
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(getValue('email'))) {
      showStatus('メールアドレスの形式を確認してください。', false);
      trackValidationFail('email', 'format');
      return false;
    }

    return true;
  }

  function botCheckFailed() {
    var honeypot = getValue('website');
    if (honeypot) return true;
    if (Date.now() - state.pageLoadTime < 1000) return true;
    if (!state.userInteracted) return true;
    return false;
  }

  // 会社名の候補で選んだ会社（assets/company-candidates.js）を相談内容の末尾に 1 行足す
  function withCompanyCandidate(message) {
    var field = qs('[name="companyCandidateLine"]', state.form);
    if (!field || !field.value) return message;
    return (message ? message + '\n' : '') + field.value;
  }

  function buildPayload() {
    var device = getDeviceInfo();
    var inquiryId = getValue('inquiry_id') || generateInquiryId();
    setField('inquiry_id', inquiryId);

    return {
      action: 'business_inquiry',
      form_type: 'business_inquiry',
      inquiry_id: inquiryId,
      timestamp: new Date().toISOString(),
      name: getValue('name'),
      company: getValue('company'),
      email: getValue('email'),
      phone: getValue('phone'),
      message: withCompanyCandidate(getValue('message')),
      role: getValue('role'),
      project_type: getValue('project_type'),
      install_place: getValue('install_place'),
      construction_scope: getValue('construction_scope'),
      drawing_status: getValue('drawing_status'),
      requested_documents: getCheckedValues('requested_documents'),
      product_url: getValue('product_url'),
      desired_delivery: getValue('desired_delivery'),
      product_handle: getValue('product_handle') || parseProductHandle(getValue('product_url')),
      collection_handle: getValue('collection_handle'),
      current_url: getValue('current_url'),
      page_title: getValue('page_title'),
      cta_label: getValue('cta_label'),
      active_audience: getActiveAudience(),
      referrer: getValue('referrer'),
      utm_source: getValue('utm_source'),
      utm_medium: getValue('utm_medium'),
      utm_campaign: getValue('utm_campaign'),
      user_agent: getValue('user_agent'),
      device_type: device.type,
      screen_width: device.screenWidth,
      browser: device.browser,
      os: device.os,
      elapsed_ms: Date.now() - state.pageLoadTime
    };
  }

  function sendBusinessSubmitEvent(payload) {
    if (typeof gtag !== 'function') return;
    if (window.idetoxAdsUserData) window.idetoxAdsUserData({ email: payload.email, phone: payload.phone }, { sendEvent: true });
    gtag('event', 'business_form_submit', {
      event_category: 'contact',
      event_label: 'business_inquiry',
      form_name: 'business_inquiry',
      form_id: 'BusinessInquiryForm',
      inquiry_id: payload.inquiry_id,
      cta_label: payload.cta_label || '',
      active_audience: payload.active_audience || '', // どの対象者タブ表示中に送信されたか
      product_handle: payload.product_handle || '',
      collection_handle: payload.collection_handle || '',
      transport_type: 'beacon'
    });
  }

  function sendSimpleEvent(eventName, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', eventName, Object.assign({
      event_category: 'business',
      current_url: window.location.href,
      page_title: document.title,
      transport_type: 'beacon'
    }, params || {}));
  }

  async function submitForm(event) {
    event.preventDefault();
    if (state.submitting || state.completed) return; // 送信中・送信済みは二重送信を防ぐ

    clearStatus();
    if (!validate()) return;

    var payload = buildPayload();
    if (botCheckFailed()) {
      state.form.reset();
      fillHiddenFields();
      showSuccess(payload);
      lockAsCompleted();
      return;
    }

    state.submitting = true;
    state.submitButton.disabled = true;
    qs('span', state.submitButton).textContent = '送信中です…';

    try {
      var response = await fetch(GAS_WEB_APP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow'
      });
      var result = { status: 'ok' };
      try {
        result = await response.json();
      } catch (e) {}
      if (!response.ok || result.status !== 'ok') {
        throw new Error(result.message || 'submit failed');
      }

      sendBusinessSubmitEvent(payload);
      try {
        if (window.idetoxTrackYahooConversion) {
          window.idetoxTrackYahooConversion({ key: 'business-inquiry-' + payload.inquiry_id });
        }
      } catch (e) {}

      // OpenAI広告（ChatGPT広告）コンバージョン計測 lead_created（本物の送信成功時のみ。ボットへのフェイク成功では発火しない）
      try {
        if (window.oaiq) {
          window.oaiq('measure', 'custom', { type: 'custom' }, { custom_event_name: 'idetox_contact_lead' });
        }
      } catch (e) {}

      state.submitting = false;
      state.form.reset();
      fillHiddenFields();
      showSuccess(payload);
      lockAsCompleted(); // 成功後はボタンを「送信が完了しました」に固定（再送信不可）
    } catch (error) {
      // エラー時のみ再送信できるよう戻す
      state.submitting = false;
      state.submitButton.disabled = false;
      qs('span', state.submitButton).textContent = state.submitLabel;
      showStatus('送信中にエラーが発生しました。お手数ですが、時間をおいて再度お試しください。', false);
      sendSimpleEvent('business_form_submit_error', {
        event_label: 'business_inquiry',
        inquiry_id: payload.inquiry_id
      });
    }
  }

  function bindEvents() {
    state.form.addEventListener('input', function() {
      state.userInteracted = true;
    });
    state.form.addEventListener('change', function() {
      state.userInteracted = true;
    });
    state.form.addEventListener('submit', submitForm);

    qsa('[data-business-phone]').forEach(function(link) {
      link.addEventListener('click', function() {
        sendSimpleEvent('business_phone_click', {
          event_label: link.textContent.trim()
        });
      });
    });
  }

  function init(scope) {
    // scope 指定時はその範囲を優先（ブログ埋め込み）。無ければ document 全体から探す。
    var form = qs('[data-business-inquiry-form]', scope) || qs('[data-business-inquiry-form]');
    if (!form) return;
    if (form.getAttribute('data-idetox-bound') === '1') return; // 二重初期化ガード
    form.setAttribute('data-idetox-bound', '1');

    state.form = form;
    state.submitButton = qs('[data-business-submit]', state.form);
    state.status = qs('[data-business-status]', state.form);
    state.submitLabel = qs('span', state.submitButton).textContent;
    fillHiddenFields();
    bindEvents();
  }

  // ブログ本文への埋め込み（form-embed.js）から呼べるよう公開
  window.idetoxBusinessFormInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
